import { render } from "./RightCards.vue?vue&type=template&id=310b5447"
import script from "./RightCards.vue?vue&type=script&lang=js"
export * from "./RightCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__